/* src/app/shared/components/ag-button-v2/ag-button-v2.component.scss */
.ag-button {
  box-sizing: border-box;
  line-height: normal;
  border: 1px solid transparent;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ag-button p {
  font-family: "Poppins-Regular";
  margin: 0 !important;
}
.ag-button.ag-type-primary-destructive-false:hover {
  opacity: 0.9;
}
.ag-button.ag-type-secondary-destructive-false:hover {
  opacity: 0.85;
}
.ag-button.ag-type-tertiary-destructive-false:hover {
  opacity: 0.9;
}
.ag-button.ag-type-primary-destructive-true:hover {
  opacity: 0.9;
}
.ag-button.ag-type-secondary-destructive-true:hover {
  opacity: 0.85;
}
.ag-button.ag-type-tertiary-destructive-true:hover {
  opacity: 0.9;
}
.ag-button.ag-size-small {
  height: 40px;
  max-height: 40px;
  width: fit-content;
  border-radius: 12px;
  padding: 10px 16px 10px 16px;
}
.ag-button.ag-size-medium {
  height: 48px;
  max-height: 48px;
  width: fit-content;
  border-radius: 12px;
  padding: 14px 16px 14px 16px;
}
.ag-button.ag-size-large {
  max-height: 56px;
  height: 56px;
  width: fit-content;
  border-radius: 16px;
  padding: 18px 16px 18px 16px;
}
.ag-button.ag-type-primary-destructive-false {
  background-color: #222222;
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.3);
}
.ag-button.ag-type-primary-destructive-false span {
  color: #ffffff;
  font-family: "Poppins-SemiBold";
  font-style: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ag-button.ag-type-primary-destructive-false span p {
  color: #ffffff;
}
.ag-button.ag-type-primary-destructive-false .lds-ring div {
  border: 1.5px solid #ffffff;
  border-color: #ffffff #ffffff #ffffff transparent;
}
.ag-button.ag-type-secondary-destructive-false {
  background: #f2f2f2;
}
.ag-button.ag-type-secondary-destructive-false span {
  color: #222222;
  font-family: "Poppins-SemiBold";
  font-style: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ag-button.ag-type-secondary-destructive-false span p {
  color: #222222;
}
.ag-button.ag-type-tertiary-destructive-false {
  background-color: transparent;
}
.ag-button.ag-type-tertiary-destructive-false span {
  color: #222222;
  font-family: "Poppins-SemiBold";
  font-style: normal;
  font-size: 14px;
  text-decoration-line: underline;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ag-button.ag-type-tertiary-destructive-false span p {
  color: #222222;
}
.ag-button.ag-type-primary-destructive-true {
  background-color: #e55e5e;
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.3);
}
.ag-button.ag-type-primary-destructive-true span {
  color: #ffffff;
  font-family: "Poppins-SemiBold";
  font-style: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ag-button.ag-type-primary-destructive-true span p {
  color: #ffffff;
}
.ag-button.ag-type-primary-destructive-true .lds-ring div {
  border: 1.5px solid #ffffff !important;
  border-color: #ffffff #ffffff #ffffff transparent !important;
}
.ag-button.ag-type-secondary-destructive-true {
  background: #fff2f0;
}
.ag-button.ag-type-secondary-destructive-true span {
  color: #e55e5e;
  font-family: "Poppins-SemiBold";
  font-style: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ag-button.ag-type-secondary-destructive-true span p {
  color: #e55e5e;
}
.ag-button.ag-type-tertiary-destructive-true {
  background-color: transparent;
}
.ag-button.ag-type-tertiary-destructive-true span {
  color: #e55e5e;
  font-family: "Poppins-SemiBold";
  font-style: normal;
  font-size: 14px;
  text-decoration-line: underline;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ag-button.ag-type-tertiary-destructive-true span p {
  color: #e55e5e;
}
.ag-type-disabled-primary {
  background-color: #dfdfdf !important;
  cursor: default !important;
}
.ag-type-disabled-primary div span {
  color: #a6a6a6 !important;
}
.ag-type-disabled-primary .lds-ring div {
  border: 1.5px solid #222222 !important;
  border-color: #222222 #222222 #222222 transparent !important;
}
.ag-type-disabled-primary img {
  filter: brightness(0) saturate(100%) invert(65%) !important;
}
.ag-type-disabled-secondary {
  background-color: #ffffff !important;
  border: 1px solid #dfdfdf !important;
  cursor: default !important;
}
.ag-type-disabled-secondary div span {
  color: #a6a6a6 !important;
}
.ag-type-disabled-secondary img {
  filter: brightness(0) saturate(100%) invert(65%) !important;
}
.ag-type-disabled-tertiary div span {
  color: #a6a6a6 !important;
}
.ag-type-disabled-tertiary img {
  filter: brightness(0) saturate(100%) invert(65%) !important;
}
.filter-black-image {
  filter: brightness(0) invert(1);
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 21px;
  height: 21px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 21px;
  height: 21px;
  border: 1.5px solid #222222;
  border-radius: 50%;
  animation: lds-ring 0.85s linear infinite;
  border-color: #222222 #222222 #222222 transparent;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=ag-button-v2.component.css.map */
